import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'use-http';

import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { generateGuid } from '@bingads-webui-universal/primitive-utilities';

export function getDefaultUrl(serverContext) {
  const { CampaignAPI } = serverContext.ServicesEndpoints;

  return `${CampaignAPI}mmp/`;
}

export function getDefaultOptions(serverContext) {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      lcid: serverContext.CurrentUser.Locale,
      'x-ms-clientapplication': 'bingadsweb', // required, will get 401 if missing
      'x-ms-pagetrackingid': serverContext.PageTrackingId,
      Authorization: `CCMTSmallToken ${serverContext.Token}`,
    },
    cachePolicy: 'no-cache',
    interceptors: {
      request: ({ options }) => {
        // eslint-disable-next-line no-param-reassign
        options.headers['x-ms-requestid'] = generateGuid();

        return options;
      },
    },
  };

  return defaultOptions;
}

export function MmpFetchProvider({ url, options, children }) {
  const serverContext = useContext(ServerContext);
  const finalOptions = getDefaultOptions(serverContext);

  if (options && options.headers) {
    finalOptions.headers = { ...finalOptions.headers, ...options.headers };
  }

  const finalUrl = url || getDefaultUrl(serverContext);

  return (
    <Provider url={finalUrl} options={finalOptions}>
      {children}
    </Provider>
  );
}

MmpFetchProvider.propTypes = {
  url: PropTypes.string,
  options: PropTypes.shape({
    headers: PropTypes.shape({}),
  }),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

MmpFetchProvider.defaultProps = {
  url: undefined,
  options: undefined,
};
